import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

export const applicationService = {
  // Get all applications for a specific job requisition
  getApplications: async (requisitionId) => {
    return await axios.get(`${API_URL}/applications`, {
      params: { requisitionId },
    });
  },

  // Get a single application by ID
  getApplication: async (applicationId) => {
    return await axios.get(`${API_URL}/applications/${applicationId}`);
  },

  // Create a new application
  createApplication: async (applicationData) => {
    return await axios.post(`${API_URL}/applications`, applicationData);
  },

  // Update an application
  updateApplication: async (applicationId, applicationData) => {
    return await axios.put(
      `${API_URL}/applications/${applicationId}`,
      applicationData
    );
  },

  // Update application stage
  updateApplicationStage: async (applicationId, stageData) => {
    return await axios.patch(
      `${API_URL}/applications/${applicationId}/stage`,
      stageData
    );
  },

  // Add a comment to an application
  addComment: async (applicationId, comment) => {
    return await axios.post(
      `${API_URL}/applications/${applicationId}/comments`,
      { comment }
    );
  },

  // Get application timeline
  getTimeline: async (applicationId) => {
    return await axios.get(`${API_URL}/applications/${applicationId}/timeline`);
  },

  // Schedule an interview
  scheduleInterview: async (applicationId, interviewData) => {
    return await axios.post(
      `${API_URL}/applications/${applicationId}/interviews`,
      interviewData
    );
  },

  // Add evaluation feedback
  addEvaluation: async (applicationId, evaluationData) => {
    return await axios.post(
      `${API_URL}/applications/${applicationId}/evaluations`,
      evaluationData
    );
  },

  // Get all documents associated with an application
  getDocuments: async (applicationId) => {
    return await axios.get(
      `${API_URL}/applications/${applicationId}/documents`
    );
  },

  // Upload a document for an application
  uploadDocument: async (applicationId, formData) => {
    return await axios.post(
      `${API_URL}/applications/${applicationId}/documents`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};

export default applicationService;
